import { Image, Text, View } from '@react-pdf/renderer';
import DateTimeHelpers from '../../../utils/date-time-helpers.utils';
import styles from '../pro-report-pdf-styles';

function ProReportHeader() {
  const accurateAsOf = ` Accurate as of ${DateTimeHelpers.getCurrentUtcDateTime()}`;
  return (
    <View style={styles.header}>
      <Image
        src="/assets/images/NorthStandard_Full_Logo_Purple_RGB.png"
        style={styles.logo}
      />
      <View style={styles.textContainer}>
        <Text style={styles.textTop}>GlobeView PRO Report</Text>
        <Text style={styles.textBottom}>{accurateAsOf}</Text>
      </View>
    </View>
  );
}

export default ProReportHeader;
